import React, { useState } from "react";
import { TableUi } from "../../components/table.ui";
import { useMutation, useQuery } from "react-query";
import GymSpaService from "../../services/gym_spa.service"
import { Badge, Modal, Progress } from "flowbite-react";
import { ButtonUi, LoadingUi } from "../../components/components";
import { useAuth } from "../../middleware/auth.middleware";
import { useForm } from "react-hook-form";
import { CalendarIcon, CurrencyDollarIcon, MailIcon, PhoneIcon } from "@heroicons/react/outline";
import {InputUi} from '../../components/input.ui'
import { toast } from "react-toastify";

export const AttenteGYMSPA = () => {
  const _form = useForm({mode: 'all'});
  const {role} = useAuth()
  const _gymspa = useQuery(['gymspa', role]);

  const inputParams = [
    {
      label: 'Prix',
      placeholder: 'prix',
      name: 'prix',
      type: 'number',
      leftIcon: CurrencyDollarIcon,
      error: _form.formState.errors?.prix?.message,
      validations: {
        required: 'prix est réquis',
      }
    },
    {
      label: 'Date début',
      placeholder: 'début',
      name: 'dateDebut',
      type: 'datetime-local',
      leftIcon: CalendarIcon,
      error: _form.formState.errors?.dateDebut?.message,
      validations: {
        required: 'dateDebut est réquis',
      }
    },
    {
      label: 'Date fin',
      placeholder: 'fin',
      name: 'dateFin',
      type: 'datetime-local',
      leftIcon: CalendarIcon,
      error: _form.formState.errors?.dateFin?.message,
      validations: {
        required: 'dateFin est réquis',
      }
    }
  ]

  const [state, setState] = useState({
    showModal: false,
    type: 'rejet',
    gymspaId: null,
  })

  const initState = () => setState({ 
    ...state, 
    showModal:false,
    type: 'rejet', 
    gymspaId: null,
  })

  const _rejeter = useMutation(GymSpaService.rejeter, {
    onSuccess: resp => {
      setState({...state, showModal: false, gymspaId: null})
      _gymspa.refetch()
      toast.success('Rejetée avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    },
  })
  const _payer = useMutation(GymSpaService.payment, {
    onSuccess: resp => {
      setState({...state, showModal: false, gymspaId: null })
      _gymspa.refetch()
      toast.success('Payement effectué avec succès')
    },
    onError: resp => {
      if(resp?.response?.data?.error){
        toast.error(resp?.response?.data?.error)
      } else
      toast.error("Une erreur inconnue s'est produite")
    }
  })
  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src='/assets/employe.png'
          />
        </div>
      ),
    },
    {
      Header: "Employé",
      accessor: "userId",
      Cell: ({ cell }) => (
        <div className="">
          {
            cell.row.values.userId.prenom.charAt(0).toUpperCase()+cell.row.values.userId.prenom.slice(1)+' '+ cell.row.values.userId.nom
          }
        </div>
      ),
    },
    {
      Header: "Forfait",
      accessor: "forfait",
    },
    {
      Header: "Type",
      accessor: "typeGS",
    },
    {
      Header: "Status",
      accessor: "status",
    },
    {
      Header: "Mode de paiement",
      accessor: "methodePaiement",
    },
    {
      Header: "Action",
      Cell: ({ cell }) => (
        <div className="flex gap-3 justify-center">
          
          <span className="bg-red-200 cursor-pointer px-2 rounded-lg text-red-500 font-semibold p-1"
            onClick={() => {
              setState({
                ...state,
                showModal: !state.showModal,
                gymspaId: cell.row.values,
                type: 'rejet'
              })
            }}
          >
            Rejeter
          </span>
          <span className="bg-amber-200 cursor-pointer px-2 rounded-lg text-amber-500 font-semibold p-1"
            onClick={() => {
              _payer.reset()
              _rejeter.reset()
              setState({
                ...state,
                showModal: !state.showModal,
                gymspaId: cell.row.values,
                type: 'pay',
              })
            }}
          >
            Payer
          </span>
        </div>
      ),
    },
  ];

  const onSubmit = (r) => {
    setState({ ...state, error: null })
    let data = {
      prix: r.prix,
      dateDebut: r.dateDebut,
      dateFin: r.dateFin,
      id: state.gymspaId?._id,
    }
    if(state.type === 'pay')
      _payer.mutate(data)
    if(state.type === 'new')
      _rejeter.mutate(data)

  }

  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2">
        <div className="flex flex-row text-center justify-between">
          <div className="flex flex-col text-left">
          <h1 className="text-xl ">Les informations en attente</h1>
            
          </div>
         

          <React.Fragment>
            <Modal
              show={state.showModal}
              size={ 'sm'}
              onClose={() => initState()}>
              <Modal.Header>{
                state.type === 'pay' 
                  ? 'Effectuer le payement' 
                  : 'Rejeter'
                }</Modal.Header>
              <Modal.Body className="space-y-6">
                <div>
                  {
                    state.type === 'rejet'
                    ? <div>
                        <p className="text-gray-600 pb-5">Vous êtes sur le point de rejeter cette information, voulez-vous continuer?</p>
                        <div className="flex justify-between gap-10">
                          <button
                              onClick={() => initState()}
                              className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-gray-800 bg-gray-400 focus:outline-none"
                          >Annuler</button>
                          <button
                            type="submit"
                            onClick={() => {
                              _rejeter.mutate(state.gymspaId?._id)
                            }}
                            className="w-full flex justify-center py-2 mt-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 focus:outline-none">
                            {
                              !_rejeter.isLoading ? 'Rejeter' : <LoadingUi />
                            }
                          </button>
                        </div>
                      </div>
                    :  state.type === 'pay'
                    ? <form onSubmit={_form.handleSubmit(onSubmit)}>
                      {
                        inputParams?.map(item => {
                            return (
                              <div key={item.name}>
                                  <InputUi
                                    label={item.label}
                                    name={item.name}
                                    type={item.type}
                                    LeftIcon={item.leftIcon}
                                    placeholder={item.placeholder}
                                    register={_form.register}
                                    error={item.error}
                                    validations={item.validations}
                                    bg='gray-200'
                                    />
                                </div>
                            )
                        })
                      }
                        <div className=" pt-10">
                          <ButtonUi isLoading={_payer.isLoading || _payer.isLoading}>Payer</ButtonUi>
                        </div>
                    </form>
                    : <div/>
                  }
                </div>
              </Modal.Body>
            </Modal>
          </React.Fragment>
        </div>
      </div>

      {
        _gymspa.isSuccess && _gymspa?.data?.data?.attente?.length !== 0
          ? <TableUi columns={COLUMNS} data={_gymspa?.data?.data?.attente} colsHidden={["_id"]} />
          : <p className="text-gray-600 text-sm">Aucune information trouvée</p>

      }

    </div>
  );
};
